import { render, staticRenderFns } from "./AckModal.vue?vue&type=template&id=6637a130&scoped=true&"
import script from "./AckModal.vue?vue&type=script&lang=js&"
export * from "./AckModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637a130",
  null
  
)

export default component.exports